import { BCKSInvitationGuide } from 'app/BCKSPage/Invitation/guide'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PropsInvitationGuideIndexPage {
  isKSSelectionEnabled: boolean
}

export const getServerSideProps = async () => {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const BCKSInvitationGuideIndexPage = (props: PropsInvitationGuideIndexPage) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return <BCKSInvitationGuide />
}

// eslint-disable-next-line react/display-name
BCKSInvitationGuideIndexPage.Layout = ({ children }) => children

export default BCKSInvitationGuideIndexPage
